import React from 'react';

import { AppleLogoIcon, GooglePlayLogoIcon } from 'assets';
import { PlatformType } from '../../DownloadAppButton.types';

const Logo = ({ type, className = '' }) => {
  if (type === PlatformType.APP_STORE) {
    return <AppleLogoIcon className={className} />;
  }

  if (type === PlatformType.GOOGLE_PLAY) {
    return <GooglePlayLogoIcon className={className} />;
  }
};

export default Logo;
